import type { ReactElement } from 'react';
import { render, unmountComponentAtNode } from 'react-dom';
import { createRoot } from 'react-dom/client';

import { FeatureFlags } from 'contexts/FeatureFlags';

const FLAG_NAME = 'feature_flag_react_18_create_root';

export const isCreateRootEnabled = () => FeatureFlags.isFeatureEnabled(FLAG_NAME);

export interface MountHandle {
  unmount: () => void;
}

export const mountReactRoot = (element: ReactElement, container: Element): MountHandle => {
  if (isCreateRootEnabled()) {
    const root = createRoot(container);
    root.render(element);
    return { unmount: () => root.unmount() };
  }
  render(element, container);
  return { unmount: () => unmountComponentAtNode(container) };
};
